export interface EmptyCallback {}
export interface FormField {
  element: any;
  index: number;
  total: number;
  details: FieldDetails;
  positioning?: FieldPositioning;
}

export enum FindOptions {
  SearchUp = 1,
  MatchCase = 4,
  NoHightLight = 8,
  NoMessageBox = 16,
  MatchWholeWord = 64,
}

export interface FieldPositioning {
  //bounds?: Rectangle;
  length?: number;
  start?: number;
}
export interface FieldDetails {
  id: any;
  name: string;
  text: string;
}
export interface Rectangle {
  location: Point;
  size: Size;
}
export interface Point {
  x: number;
  y: number;
}
export interface Size {
  width: number;
  height: number;
}

export interface textViewLocationChangedEvent {
  location: Point;
}
export interface InputPositionChangedEvent {
  column: number;
  line: number;
  page: number;
  section: number;
  textPosition: number;
}
export interface SelectionPosition {
  start: number;
  length: number;
}
export interface TextFieldEventArgs {
  textField: TextfieldInfo;
}

export interface TextfieldInfo {
  bounds: Rectangle;
  containsInputPosition: boolean;
  deleteable: boolean;
  doubledInputPosition: boolean;
  editable: boolean;
  formattingBounds: Rectangle;
  id: number;
  isSpellCheckingEnabled: boolean;
  length: number;
  name: string;
  showActivated: boolean;
  start: number;
  text: string;
  type: string;
}

export interface ZoomFactorChangedEventArgs {
  zoomFactor: number;
}

export enum FindResult {
  NotFound = -1,
}

export interface PageInformation {
  pageWidth: number,
  pageHeight: number,
  marginTop: number,
  marginRight: number,
  marginBottom: number,
  marginLeft: number
}
